import Page from "@jumbo/shared/Page";
import CoreExpenses from "app/pages/Master/ExpenseMaster/CoreExpenses";
import AddExpenses from "app/pages/Master/ExpenseMaster/CoreExpenses/AddExpenses";
import AccessMiddleware from "app/routes/middleware/auth/AccessMiddleware";

export const coreExpenseRoutes = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "expense_master", "view"],
      },
    ],
    routes: [
      {
        path: "/master/expense/core",
        element: <Page component={CoreExpenses} layout={"vertical-default"} />,
      },
      {
        path: "/master/expense/core/add/:invoiceId",
        element: <Page component={AddExpenses} layout={"vertical-default"} />,
      }
    ],
  },
];
